import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import './Overview.css';
import Right_mark from "../../assets/images/right_mark.png";
import create_portal_img from '../../assets/images/create_portal_img.png';
import { useNavigate } from 'react-router-dom';

export default function Overview() {
  const navigate = useNavigate();

  const data = [
    { feature: 'Price per page', basic: '$0.15', advanced: '$0.50' },
    { feature: 'Access Control', basicImage: Right_mark, advancedImage: Right_mark },
    { feature: 'Pretrained Google NMT', basicImage: Right_mark, advancedImage: Right_mark },
    { feature: 'Custom Glossaries', basicImage: Right_mark, advancedImage: Right_mark },
    { feature: 'Custom AutoML models', basic: '', advancedImage: Right_mark },
    { feature: 'Translation memories', basic: '', advancedImage: Right_mark },
    { feature: 'Post-editing tools', basic: '', advancedImage: Right_mark }
  ];

  return (
    <div className="d-flex flex-column overflow-auto h-100">
      {/* Header Section */}
      <div className="w-100 header border-bottom position-sticky top-0 bg-white py-2">
        <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">Overview</h2>
      </div>
      {/* <Row className="my-4 mb-5 mx-3 text-start">
          <Col>
            <h3 className="fs-5 fw-600 text-start">Get Started With Acumen Translation Hub</h3>
            <p className="fs-6 text-start">
              Acumen Translation Hub provides self-service translations in more than 100 languages for organizations that require real-time document translation.
            </p>
          </Col>
        </Row> */}
      {/* Main Content with Animation */}
      <div className={`d-flex flex-grow-1 pt-5`}>
        <div className="animate-from-top">
          <h2 className="fw_400 fn_Roboto">Acumen Translation Hub - Team Edition</h2>
          <p className="fs_18 fw_400 pt-4" style={{ paddingRight: '15%', paddingLeft: '15%' }}>
            Streamlines document translation with an intuitive workflow designed for teams. Upload documents, assign tasks, and enable users to perform post-editing with ease. Team leads can review edited documents and publish the final versions seamlessly. Empower your team to collaborate efficiently and deliver high-quality translations on time.
          </p>
        </div>
      </div>
    </div>
  );
}
